module.exports = __webpack_public_path__ + "img/wlzg-banner1.7acec662.png";